export default "__VITE_ASSET__sMXWM3k8__"